import React, { FC } from 'react';
import ContactForm from './contactForm/ContactForm';
import SocialMedia from './socialMedia/SocialMedia';
import { SEO } from 'components/seo/SEO';
import { breadcrumbJsonLd } from 'components/seo/organizationSchema';
import routeManifest from 'routes/routeManifest.json';
import './ContactUs.css';

const route = routeManifest.find((r) => r.path === '/contact-us')!;
const breadcrumbs = breadcrumbJsonLd([
  { name: 'Home', path: '/' },
  { name: 'Contact Us', path: '/contact-us' },
]);

export const ContactUs: FC = () => {
  return (
    <div className='home-content-container' id='contact-us'>
      <SEO title={route.title} description={route.description} path={route.path} jsonLd={[breadcrumbs]} />
      <ContactForm />
      <SocialMedia />
    </div>
  );
};
